/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Send_NotificationInputs */

const cs_action_send_notification = /** @type {(inputs: Action_Send_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odeslat oznámení`)
};

const en_action_send_notification = /** @type {(inputs: Action_Send_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send notification`)
};

/**
* | output |
* | --- |
* | "Send notification" |
*
* @param {Action_Send_NotificationInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_send_notification = /** @type {((inputs?: Action_Send_NotificationInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Send_NotificationInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_send_notification(inputs)
	return cs_action_send_notification(inputs)
});